import React, { FunctionComponent } from 'react';
import { Portfolio } from '../../interfaces/user';
import { ReactComponent as EditIcon } from '../../assets/svg/edit.svg';

interface PortfolioItemProps {
  portfolio: Portfolio;
  onEdit?: (portfolio: Portfolio) => void;
  isOwner?: boolean;
}

const PortfolioItem: FunctionComponent<PortfolioItemProps> = ({
  portfolio,
  onEdit,
  isOwner = false
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (!(e.target as HTMLElement).closest('.portfolio-item__edit-button')) {
      window.open(portfolio.url, '_blank', 'noopener,noreferrer');
    }
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(portfolio);
    }
  };

  return (
    <div className="portfolio-item" onClick={handleClick}>
      <div className="portfolio-item__image-wrapper">
        <img
          src={portfolio.image?.includes('via.placeholder.com') ? 'https://placehold.co/800x450/1A202C/8A94A6?text=No+Thumbnail+Provided' : portfolio.image}
          alt={portfolio.title}
          className="portfolio-item__image"
        />
        {isOwner && onEdit && (
          <button
            className="portfolio-item__edit-button"
            onClick={handleEdit}
            title="Edit portfolio item"
          >
            <EditIcon />
          </button>
        )}
      </div>
      <div className="portfolio-item__content">
        <h3 className="portfolio-item__title">{portfolio.title}</h3>
      </div>
    </div>
  );
};

export default PortfolioItem;